export type CampaignFilterType = 'datePreset' | 'mandatory' | 'campaignType' | 'brands' | 'search';

export type CampaignFilterParam =
  | 'date_preset'
  | 'mandatory'
  | 'campaign_type'
  | 'brands'
  | 'start_date'
  | 'end_date'
  | 'search';

export type CampaignFilterMap = Record<CampaignFilterType, CampaignFilterParam[]>;

export const campaignFilterMap: CampaignFilterMap = {
  datePreset: ['date_preset'],
  mandatory: ['mandatory'],
  campaignType: ['campaign_type'],
  brands: ['brands'],
  search: ['search'],
};
